<template>
  <div>
    <div class="wrapper-login">
      <component
        :is="router().getRoute()"
        :provider="propsProvider"
        :captcha-public-key="propsRecapcha"
        :facebook="propsFb"
        :return-url="returnUrlValue"
        :in-frame="propsInFrame"
        :form-container-class="formContainerClass"
        :demo="demo"
        :provider-details="propsProviderDetails"
        :disable-redirect="disableRedirect"
        :template="template"
        @logged-in="onSuccessfulLogin"
      > 
        <template #terms>
          <slot name="terms"></slot>
        </template>
      </component>
    </div>
  </div>
</template>
<script>
import WindowUtilities from './WindowUtilities.vue';
import WindowMessages from './WindowMessages.vue';
import store from './store'
import { Vue3LoggerPlugin } from '@gf/gf-logger';
import constants from './gf-login-module/common/constants';
import SimpleVueValidator from "simple-vue3-validator";
import { getCurrentInstance, onBeforeMount } from 'vue'
import useAppRouter from './composables/useAppRouter';
import Login from './gf-login-module/login/login.vue'
import Register from './gf-login-module/register/register.vue';
import ForgotPassword from './gf-login-module/forgetpassword/ForgetPassword.vue';
import FbConnect from './gf-login-module/login/FacebookConnect.vue';

export default {
  name: 'GfLoginModule',
  components: {
    Login,
    Register,
    ForgotPassword,
    FbConnect,
  },
  props:{
    facebook:{
      type: Object,
      default: function () {
        return { }
      },
    },
    captchaPublicKey:{
      type: String,
      default: "",
    },
    provider: {
      type: String,
      default: "",
    },
    providerDetails: {
      type: Array,
      default: function() {
        return []
      }
    },
    returnUrl:{
      type: String,
      default: "",
    },
    inFrame:{
      type: String,
      default: "true",
    },
    customContainerClass:{
      type: String,
      default: "",
    },
    demo:{
      type: Boolean,
      default: false,
    },
    disableRedirect: {
      type: Boolean,
      default: false,
    },
    template: {
      type: String,
      default: 'inline',
    },
  },
  data() {
    return {
      inApp: false,
      returnUrlValue: "",
      router: useAppRouter,
      store: store.getters.getState,
    }
  },
  computed:{
    formContainerClass: function() {
      if (this.customContainerClass && this.customContainerClass !== "") {
        return this.customContainerClass + " bgr-main";
      }
      return "col-md-5 col-lg-5 col-xl-3 col-sm-12 col-xs-12 bgr-main"
    },
    propsFb: {
      get: function(){
        return this.facebook;
      }
    },
    propsRecapcha:{
      get: function(){
        return this.captchaPublicKey;
      }
    },
    propsProvider:{
      get: function(){
        return this.provider;
      }
    },
    propsProviderDetails: {
      get: function() {
        return this.providerDetails;
      }
    },
    propsInFrame:{
      get: function(){
        return this.inFrame;
      }
    }
  },

  setup(props) {
    getCurrentInstance().appContext.app.use(store)
    getCurrentInstance().appContext.app.use(SimpleVueValidator)
    getCurrentInstance().appContext.app.use(Vue3LoggerPlugin)

    useAppRouter().setAppProps(props)
  },

  mounted() {       
    this.returnUrlValue = this.returnUrl;
    this.processReturnUrl();
    this.$gfLogger.logInfo("GfLoginModule.mounted() - Facebook Params:", this.facebook);
    this.$gfLogger.logInfo("GfLoginModule.mounted() - providerDetails:", this.providerDetails);
  },
  methods: {

    onSuccessfulLogin: function (userEmail) {
      this.$gfLogger.logInfo("GfLoginModule.onSuccessfulLogin", userEmail);
      if (WindowUtilities.isCurrentWindowInIFrame()) {
        window.top.parent.postMessage("login from iframe successful","*")
        
        this.$emit('loggedIn', userEmail)

        this.$gfLogger.logInfo("GfLoginModule.isCurrentWindowInIFrame", userEmail);

        if ( ! this.disableRedirect) {
          this.$gfLogger.logInfo("GfLoginModule.isCurrentWindowInIFrame.reloadParentWindow");
          WindowUtilities.reloadParentWindow();
        }
        
        window.addEventListener('beforeunload', function (e) {
          e.preventDefault();
          return;
        });
      }
      this.$emit('loggedIn', userEmail)
    },
    processReturnUrl(){                
      var isModuleNeedIcludeHash = constants.INCLUDE_HASH_MODULE.filter(item => {
        return item === this.returnUrl;
      });
      if(isModuleNeedIcludeHash.length > 0){                                
        this.returnUrlValue = this.returnUrl + window.location.hash;               
      }       
    }
  },
  watch: {
    returnUrl(val) {
      this.returnUrlValue = val;
    }
  }
}
</script>
<style lang="css">
@font-face {
  font-family: 'Flaticon';
  src: url('gf-login-module/assets/fonts/Flaticon.eot');
  src: url('gf-login-module/assets/fonts/Flaticon.eot?#iefix') format('embedded-opentype'),
    url('gf-login-module/assets/fonts/Flaticon.woff') format('woff'), url('gf-login-module/assets/fonts/Flaticon.ttf') format('truetype'),
    url('gf-login-module/assets/fonts/Flaticon.svg#Flaticon') format('svg');
  font-weight: normal;
  font-style: normal;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  @font-face {
    font-family: 'Flaticon';
    src: url('gf-login-module/assets/fonts/Flaticon.svg#Flaticon') format('svg');
  }
}

* {
  font-size: 13px;
}

.bgr-main {
  max-width: 470px !important;
}
.gf-logo {
  width: 30px;
}
.message_error_login{
  color:red;
}
.navbar-login {
  background-color: #1a3a49;
}

.navbar-login ul li a{
  color:#fff;
}

.using-fb {
  display: flex;
}

.using-fb .hr-p {
  flex: 1;
  position: relative;
}

.using-fb .hr-p:before {
  content: '';
  background-color: #e9edf0;
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 50%;
}
#btnSubmit, #btnContinue {
  border-radius: 26px;
}
.using-fb .text-us {
  flex: 1;
}
.wrapper-login select{
  opacity: 0.9;
  padding: 4px !important;
}
.fb-ct p {
  color: #333;
  font-weight: bold;
}
.fb-ct p:before {
  content: '\f102';
  font-family: 'Flaticon';
  background-color: #3b5898;
  color: #fff;
  padding: 3px;
  border-radius: 50%;
  font-size: 9px;
  margin-right: 4px;
}

.login-using-fb {
  font-size: 13px;
  position: relative;
  color: #333;
}
.et_pickedDate .date-dropdown-container{
  float: right;
}
.et_pickedDate .date-dropdown-container .date-dropdown-select-wrapper:last-child select{
  margin-right: 0;
}
@media (max-width:576px){
  .et_pickedDate .date-dropdown-container{
    float: left;
  }
}
.navbar-toggler-iconflat:before {
  content: '\F101';
  font-family: 'Flaticon';
  color: #fff;
  font-size: 18px;
}
.bd-hr-col{
  display:block;
  border-bottom:1px solid #e9edf0;
}
.eb-bd-top{
  border-top: 1px solid #e9edf0;
  padding-top: 20px;
}
.eb-pt-row-login{
  padding-bottom: 50px;
}
.secondarybtn {
  border-radius: 26px;
  font-weight: bold;
}
#fblog {
  border-radius: 26px;
  color: #fff;
  background-color: #3b5997;
  font-weight: bold;
}
#fblog:before {
  content: '\f100';
  font-family: Flaticon;
  padding-right: 4px;
}
a:hover {
  text-decoration: none;
}
.date_birth_error{
  border: 1px solid red;
}
.opacity-lavel{
  opacity: 0.8;
  margin-top: 0.5rem;
}
textarea:focus,
textarea.form-control:focus,
input.form-control:focus,
input[type='text']:focus,
input[type='password']:focus,
input[type='email']:focus,
input[type='number']:focus,
[type='text'].form-control:focus,
[type='password'].form-control:focus,
[type='email'].form-control:focus,
[type='tel'].form-control:focus,
.btn:focus,
[contenteditable].form-control:focus,select.form-control:focus {
  box-shadow: none;
}
.checked-email-display {
  border: 1px solid rgba(255, 255, 255, 0);
  cursor: pointer;
  height: 38px;
  margin-top: 8px;
  padding: 9px 9px 9px 8px;
  transition: background-color 0.2s ease-in-out 0s, border-color 0.2s ease-in-out 0s;
}
.checked-email-display:hover {
  background: rgb(250, 251, 252);
  border-color: rgb(244, 245, 247);
}
.edit-icon-wrapper {
  float: right;
}
.edit-icon {
  color: rgb(66, 82, 110);
  --icon-primary-color: currentColor;
  --icon-secondary-color: var(--ds-surface, #FFFFFF);
}
</style>
